// extracted by mini-css-extract-plugin
export default {"item-img":"CartItem_item-img__Bgwgv","img-title":"CartItem_img-title__Od8++"};